import { render } from "./SingleUserPage.vue?vue&type=template&id=7f22f3b2&scoped=true"
import script from "./SingleUserPage.vue?vue&type=script&lang=js"
export * from "./SingleUserPage.vue?vue&type=script&lang=js"

import "./SingleUserPage.vue?vue&type=style&index=0&id=7f22f3b2&scoped=true&lang=css"

import exportComponent from "/home/runner/work/Pacto_console/Pacto_console/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f22f3b2"]])

export default __exports__